// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

// 导入页面组件
import LoginPage from '@/components/LoginPage.vue';
import RegisterPage from '@/components/RegisterPage.vue';
import AgentInfo from '@/components/AgentInfo.vue';
import CoinRecord from '@/components/CoinRecord.vue';
import UserList from '@/components/UserList.vue';
import CommissionHelp from '@/components/CommissionHelp.vue';
import AgentLinkHelp from '@/components/AgentLinkHelp.vue';
import TransferOut from '@/components/TransferOut.vue';



const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { 
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: RegisterPage,
    meta: { 
      title: '注册'
    }
  },
  {
    path: '/agentInfo',
    name: 'AgentInfo',
    component: AgentInfo,
    meta: { 
      title: '账号信息',
      showNav:true
    }
  },
  {
    path: '/coinrecord',
    name: 'CoinRecord',
    component: CoinRecord,
    meta: { 
      title: '佣金记录',
      showNav:true
    }
  },
  {
    path: '/userlist',
    name: 'UserList',
    component: UserList,
    meta: { 
      title: '用户列表',
      showNav:true
    }
  },
  {
    path: '/commissionhelp',
    name: 'CommissionHelp',
    component: CommissionHelp,
    meta: { 
      title: '佣金比例说明',
      showNav:true
    }
  },
  {
    path: '/agentlinkhelp',
    name: 'AgentLinkHelp',
    component: AgentLinkHelp,
    meta: { 
      title: '代理链接说明',
      showNav:true
    }
  },
  {
    path: '/transferOut',
    name: 'TransferOut',
    component: TransferOut,
    meta: { 
      title: '转出佣金',
      showNav:true
    }
  },
  {
    path: '/',
    redirect: 'login'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // 设置标题
  document.title = to.meta.title || '默认标题'; // 回退默认值
  next();
});

export default router;